// noinspection ES6UnusedImports
import React from 'react'

import defaultPostTypeConfig from '../post'
import getConstants from './constants'
import getMenu from './menu'

import New from './New'
import Content from './Content'
import Refund from './Refund'

import { tableComponents, tableIcons } from './Content/tableComponents'
import { defaultGetPageName } from '../../components/Post/utils'
import FilterForm from './FilterForm'

function getCustomValidationForDate() {
    return function customValidationForDate(p) {

        const {
            showInitializationErrors,
            messages,
            name
        } = p

        return function custom(value, changedEver) {
            const regex = /^\d{4}-\d{2}-\d{2}$/

            if ((changedEver || (!changedEver && showInitializationErrors))) {
                if (value) {
                    if (!regex.test(value)) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDateFormat']
                        }
                    }

                    const d = new Date(value)
                    if (isNaN(d.getTime())) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDate']
                        }
                    }

                    const [yyyy, mm, dd] = value.split('-').map(Number)
                    if (d.getUTCFullYear() !== yyyy || (d.getUTCMonth() + 1) !== mm || d.getUTCDate() !== dd) {
                        return {
                            error: true,
                            errorMessage: messages[name + 'ValidationInvalidDate']
                        }
                    }
                }
            }

            return { error: false, errorMessage: '' }
        }

    }
}

const postTypeConfig = {
    getStatusManager: function getStatusManager(p = {}) {
        return defaultPostTypeConfig.getStatusManager({
            ...p,
            config: {
                requiredDataForStatus: {
                    paymentId: { type: String },
                    total: { type: Number },
                    totalNet: { type: Number }
                },
                ...(p.config) ? p.config : {}
            }
        })
    },
    getConstants: getConstants,
    setContents: function setContents(p = {}) {
        const name = 'payment'

        const { wapp } = p

        const r = defaultPostTypeConfig.setContents({
            ...p,
            name,
            urlParams: [
                '/page/:pagination',
                '/sort/:sort',
                '/limit/:limit'
            ]
        })

        const contentProps = wapp.contents.get(name)

        wapp.contents.add({
            [name]: {
                ...contentProps,
                robots: () => {
                    return 'noindex,nofollow'
                }
            }
        })

        return r
    },
    requestForUserPage: async function requestForUserPage(p = {}) {
        return await defaultPostTypeConfig.requestForUserPage({
            ...p,
            name: 'payment'
        })
    },
    getComponent: function(p) {

        const name = 'payment'

        const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'

        const { context, appContext } = p
        const { routes } = appContext

        const { res, req } = context
        const route = res.wappResponse.route
        const requestPath = route.requestPath
        const user = req.wappRequest.user

        const isAdmin = user && user._status_isFeatured

        if ((requestPath.startsWith(routes[name + 'Route'])) || (requestPath.startsWith(routes[ns + 'Route']))) {

            const pages = {
                content: Content,
                new: New,
                refund: Refund
            }

            if (requestPath.startsWith(routes[ns + 'Route']) && !isAdmin) {
                return null
            }

            const requestKeys = [name + 'FindById']
            const post = requestKeys.map((requestName) => res.wappResponse.store.getState('res.responses.' + requestName)).find((r) => r?._id)
            const isAuthor = ((user?._id && user._id.toString() === post?._author) || (user?._id && user._id.toString() === post?._author?._id))

            const isAuthorOrAdmin = (isAuthor || isAdmin)

            if (requestPath.match(routes[name + 'Refund']) && !isAdmin) {
                return null
            }

            if (requestPath.match(routes[name + 'Refund']) && !post?.refundButton) {
                return null
            }

            if (requestPath.startsWith(routes[name + 'Route']) && requestPath !== routes[name + 'Route'] + '/new' && !isAuthorOrAdmin) {
                return null
            }

            return defaultPostTypeConfig.getComponent({
                ...p,
                name,
                archiveComponentProps: {
                    type: 'table',
                    tableProps: {
                        components: tableComponents,
                        icons: tableIcons,
                        showLabelTitle: true
                    },
                    getMenu: (p) => getMenu(p).map((m) => {
                        delete m.featured
                        return m
                    }),
                    selectable: () => false,
                    selectFunctions: [],
                    ListToolsProps: {
                        filterProps: {
                            Form: FilterForm,
                            formProps: {
                                formData: {
                                    createdDate: {
                                        isContainer: true,
                                        hiddenContainer: true
                                    },
                                    ['_operators._createdDate.gt']: {
                                        containerKey: 'createdDate._createdDateGt',
                                        label: appContext.labels[ns + 'FilterCreatedDateFrom'],
                                        helperText: '2001-01-01',
                                        componentName: 'Calendar',
                                        validations: {
                                            custom: getCustomValidationForDate()
                                        }
                                    },
                                    ['_operators._createdDate.lt']: {
                                        containerKey: 'createdDate._createdDateLt',
                                        label: appContext.labels[ns + 'FilterCreatedDateTo'],
                                        helperText: '2001-01-01',
                                        componentName: 'Calendar',
                                        validations: {
                                            custom: getCustomValidationForDate()
                                        }
                                    },
                                    paymentProviders: {
                                        isContainer: true,
                                        hiddenContainer: true
                                    },
                                    ['_operators.khbPaymentId.exists']: {
                                        containerKey: 'paymentProviders._khbPaymentIdExists',
                                        label: appContext.labels[ns + 'FilterKhbPaymentId'],
                                        componentName: 'TrueOrNull'
                                    },
                                    ['_operators.barionPaymentId.exists']: {
                                        containerKey: 'paymentProviders._barionPaymentIdExists',
                                        label: appContext.labels[ns + 'FilterBarionPaymentId'],
                                        componentName: 'TrueOrNull'
                                    },
                                    ['paymentStatus']: {
                                        containerKey: 'paymentProviders.paymentStatus',
                                        label: appContext.labels[ns + 'FilterPaymentStatusLabel'],
                                        placeholder: appContext.labels[ns + 'FilterPaymentStatusPlaceholder'],
                                        componentName: 'Select',
                                        options: [
                                            { label: appContext.labels[ns + 'FilterPaymentStatusOption1'], value: 10 },
                                            { label: appContext.labels[ns + 'FilterPaymentStatusOption2'], value: 20 },
                                            { label: appContext.labels[ns + 'FilterPaymentStatusOption3'], value: 30 }
                                        ]
                                    }
                                }
                            },
                            exportable: true
                        }
                    }
                },
                componentProps: {
                    pages,
                    showAuthor: ({ user }) => user?._status_isFeatured,
                    //showCreatedDate: ({ user, author }) => user?._id && user._id === author?._id,
                    getProps: ({ pageName }) => {

                        if (pageName === 'content') {

                            return {
                                showAuthor: () => false,
                                PaperComponentProps: {
                                    color: undefined,
                                    elevation: 0,
                                    style: {
                                        padding: 0
                                    }
                                }
                            }

                        }

                        if (pageName === 'refund') {
                            return {
                                getTitle: (p) => {
                                    if (p.pageName === 'refund') {
                                        return p.post?.title
                                    }
                                    return p.defaultGetTitle(p)
                                }
                            }
                        }

                        return {}
                    },
                    getMenu,
                    getPageName: (props) => {
                        const isAdmin = props.user?._status_isFeatured
                        if (props.page === 'refund') {
                            if (!isAdmin) {
                                return null
                            }
                            return 'refund'
                        }
                        const r = defaultGetPageName(props)
                        if (r === 'edit') {
                            return null
                        }
                        return r
                    }
                }
            })
        }
    },
    userPageFunctions: function(p) {

        const { context } = p

        const n = 'payment'
        const ns = (n.endsWith('y')) ? n.slice(0, -1) + 'ies' : n + 's'

        const { res } = context

        const wappResponse = res.wappResponse
        const route = wappResponse.route
        const { params } = route
        const { pageType } = params

        const r = defaultPostTypeConfig.userPageFunctions({
            ...p, name: n, nsPageProps: {
                tableProps: {
                    components: tableComponents,
                    icons: tableIcons,
                    showLabelTitle: true
                },
                getMenu,
                selectable: () => false,
                selectFunctions: [],
                type: 'table'
            }
        })

        //const {userStatusManager} = appContext;

        function addMenuItems() {
            return []
        }

        function addContentMenuItems() {
            return []
        }

        function getPageName({ user, post, page }) {

            const isAdmin = user && user._status_isFeatured
            const isAuthor = ((user?._id && user._id === post?._author) || (user?._id && user._id === post?._author?._id))
            const isAuthorOrAdmin = (isAdmin || isAuthor)

            return (
                (page === ns && !pageType) ||
                (page === ns && !isNaN(Number(pageType)) && Number(pageType) >= 1) ||
                (page === ns && pageType === 'deleted' && isAuthorOrAdmin) ||
                (page === ns && pageType === 'banned' && isAdmin)
            ) ? (isAdmin) ? page : 'notFound' : null

        }

        return {
            ...r,
            addMenuItems,
            addContentMenuItems,
            getPageName
        }
    },
    adminMenu: function(p) {

        const name = 'payment'

        const defaultAdminMenu = defaultPostTypeConfig.adminMenu({ ...p, name })
        defaultAdminMenu.order = 40
        defaultAdminMenu.items = defaultAdminMenu.items.filter((item, i) => {
            return (i === 0 || i === 1 || i === 2 || i === 6 || i === 7)
        })
        return defaultAdminMenu
    }
}

export default postTypeConfig
